import { useEffect } from 'react';

import { ITradingAccount } from '@aqx-core/common/api/user-account';
import { checkIsNative } from '@aqx-core/common/validators';

import { TRADING_ACCOUNT_CHANNEL_NAME } from './constants';
import { ITradingAccountMessageData } from './types';

export const broadcastTradingAccountChangeMessage = ({ metatraderId, serverId }: ITradingAccountMessageData) => {
  if (checkIsNative()) {
    return;
  }
  const channel = new BroadcastChannel(TRADING_ACCOUNT_CHANNEL_NAME);
  channel.postMessage({ metatraderId, serverId });
  channel.close();
};

export const useSyncTradingAccount = (currentAccount: ITradingAccount | undefined) => {
  useEffect(() => {
    const channel = new BroadcastChannel(TRADING_ACCOUNT_CHANNEL_NAME);
    channel.onmessage = (event: MessageEvent<ITradingAccountMessageData>) => {
      const { metatraderId, serverId } = event.data ?? {};

      const shouldRefreshTradingAccount =
        !!metatraderId &&
        !!currentAccount?.metatraderId &&
        !!serverId &&
        !!currentAccount?.serverId &&
        (metatraderId !== currentAccount.metatraderId || serverId !== currentAccount.serverId);

      if (shouldRefreshTradingAccount) {
        window.location.reload();
      }
    };
    return () => channel.close();
  }, [currentAccount]);
};
